import React from 'react';
import './UsersList.css';

const UsersList = ({ users, onEdit, onDelete, onToggleStatus }) => {
  const getRoleName = (role) => {
    switch (role) {
      case 'admin':
        return 'Administrator';
      case 'operator':
        return 'Bediener';
      case 'viewer':
        return 'Betrachter';
      default:
        return role;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (users.length === 0) {
    return (
      <div className="no-users">
        <p>Keine Benutzer vorhanden.</p>
      </div>
    );
  }

  return (
    <div className="users-list">
      <table className="users-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>E-Mail</th>
            <th>Rolle</th>
            <th>Status</th>
            <th>Letzter Login</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{getRoleName(user.role)}</td>
              <td>
                <label className="status-switch">
                  <input
                    type="checkbox"
                    checked={user.active}
                    onChange={(e) => onToggleStatus(user.id, e.target.checked)}
                  />
                  <span className="slider"></span>
                  <span className="status-text">
                    {user.active ? 'Aktiv' : 'Inaktiv'}
                  </span>
                </label>
              </td>
              <td>{formatDate(user.last_login)}</td>
              <td>
                <div className="action-buttons">
                  <button
                    className="edit-button"
                    onClick={() => onEdit(user)}
                    title="Bearbeiten"
                  >
                    ✏️
                  </button>
                  <button
                    className="delete-button"
                    onClick={() => onDelete(user.id)}
                    title="Löschen"
                  >
                    🗑️
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UsersList;